export const prefix = '[Program Class Paper Assessments]';
